import { SurveyRangeList } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/survey-range-list";
import { SurveyRange } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/survey-range";
import { SurveyRadio } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/survey-radio";
import { SurveyText } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/survey-text";

export const SurveyQuestion = ({
  node,
  index,
}: {
  node: SurveyNodeVM;
  index: number;
}) => {
  const { label, payload, type, required } = node;
  return (
    <div className={"min-w-[304px]"}>
      <div
        className={`sticky top-0 mb-4 max-w-[336px] bg-white pb-2 text-lg font-semibold text-zinc-950`}
      >
        {label} {required && <span className={"text-red-500"}>*</span>}
      </div>
      {type === "range-list" && (
        <SurveyRangeList
          payload={payload as SurveyNodePayloadRangeListVM}
          index={index}
        />
      )}
      {type === "range" && (
        <SurveyRange
          payload={payload as SurveyNodePayloadRangeVM}
          index={index}
        />
      )}
      {type === "radio" && (
        <SurveyRadio
          payload={payload as SurveyNodePayloadRadioVM}
          index={index}
        />
      )}
      {type === "text" && <SurveyText index={index} />}
    </div>
  );
};
